/*eslint-disable*/
import React, { useContext, useEffect, useRef, useState } from "react"
import isEmail from "validator/lib/isEmail"
import isURL from "validator/lib/isURL"
import isMobilePhone from "validator/es/lib/isMobilePhone"
import { ContentState, convertFromHTML, convertToRaw, EditorState } from "draft-js"
import { GridLoader } from "react-spinners"

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles"
import InputAdornment from "@material-ui/core/InputAdornment"
import Paper from "@material-ui/core/Paper"
import Divider from "@material-ui/core/Divider"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Switch from "@material-ui/core/Switch"
import { Tooltip } from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"

// core components
import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import CustomInput from "components/CustomInput/CustomInput.js"
import Button from "components/CustomButtons/Button.js"
import Card from "components/Card/Card.js"
import CardHeader from "components/Card/CardHeader.js"
import CardText from "components/Card/CardText.js"
import CardBody from "components/Card/CardBody.js"

// Icons
import {
  AlternateEmail,
  Apartment,
  InfoRounded,
  Lock,
  Phone,
  BusinessCenter,
  Schedule,
  Security,
  Settings,
  CheckCircle,
  Save,
} from "@material-ui/icons"
import Favorite from "@material-ui/icons/Favorite"

// Private Component
import JAlert from "../../components/smallComponent/jAlert"
import WorkingHours from "../../utils/hours/workingHours"
import ChangePasswordModal from "../../components/Button/ChangePasswordModal"

// Context & API
import authContext from "../../context/AuthContext"
import {
  getBusinessType,
  getMultiproAccountData,
  setMultiproAccountData,
} from "../../api/companyAction"
import config from "../../config"
import {
  getMPNameFromLocalStorage,
  setMPNameFromLocalStorage,
} from "../../services/AuthApi"

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js"
import buttonStyles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js"
import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle"
import customCheckboxRadioSwitch from "../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch"

const localStyles = {
  mainContainer: {
    background: "linear-gradient(135deg, #667eea 0%, #0d142b 100%)",
    minHeight: "100vh",
    padding: "40px 20px",
    borderRadius: "12px",
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  headerCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "24px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
  },
  pageTitle: {
    fontSize: "32px",
    fontWeight: "700",
    color: "#2d3748",
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  pageSubtitle: {
    fontSize: "16px",
    color: "#718096",
    fontWeight: "400",
  },
  demoTag: {
    display: "inline-block",
    padding: "4px 12px",
    background: "#fef3c7",
    color: "#92400e",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    marginLeft: "12px",
  },
  sectionCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "24px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "2px solid #e2e8f0",
  },
  sectionIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2d3748",
    margin: 0,
  },
  sectionDescription: {
    fontSize: "14px",
    color: "#718096",
    margin: 0,
  },
  inputGroup: {
    marginBottom: "24px",
  },
  infoBox: {
    background: "#eff6ff",
    border: "2px solid #bfdbfe",
    borderRadius: "12px",
    padding: "16px",
    marginTop: "24px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  infoIcon: {
    color: "#3b82f6",
    marginTop: "2px",
  },
  infoText: {
    fontSize: "14px",
    color: "#1e40af",
    lineHeight: "1.6",
    margin: 0,
  },
  saveButton: {
    background: "linear-gradient(135deg, #667eea 0%, #0d142b 100%)",
    color: "white",
    padding: "14px 40px",
    fontSize: "16px",
    fontWeight: "600",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
    },
  },
  successBadge: {
    background: "#d1fae5",
    color: "#065f46",
    padding: "8px 16px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch,
}

const disabledStyle = {
  disabledBack: {
    backgroundColor: "rgba(102, 126, 234, 0.1)",
    backdropFilter: "blur(10px)",
  },
}

const useDisabledStyle = makeStyles(disabledStyle)
const useButtonStyles = makeStyles(buttonStyles)
const useLocalStyle = makeStyles(localStyles)
const useStyles = makeStyles(styles)
const useStylesExtended = makeStyles(stylesExtended)

const BASE_URL = config.BASE_URL
const ALERT_COLOR = "coral"

const label = {
  formTitle: "Mon compte",
  visuel: "Visuel",
  company: "Nom de votre société*",
  companies: "Choisir un ou plusieurs établissements",
  name: "Nom du contact",
  description: "description",
  suspended: "Suspendu ?",
  image: "Image de profil",
  openingHours: "Horaires d'ouverture par défaut",
  site: "site internet",
  phone: "Téléphone",
  save: "Enregistrer les modifications",
  latitude: "Latitude",
  longitude: "Longitude",
  address: "Adresse",
  email: "Email*",
  defaultSubCompanyPassword: "Mot de passe par défaut pour vos établissements",
  emailingEventOn: "Envoi d'email aux établissements désactivé",
  emailingEventOff: "Envoi d'email aux établissements activé",
  moreParameters: "Paramètres avancés",
  moreParametersExplanation:
    "Définissez des paramètres par défaut pour vos nouveaux établissements",
  businessType: "Type d'établissement par défaut",
  generalInfo: "Informations générales",
  generalInfoDesc: "Gérez les informations principales de votre compte",
  securitySettings: "Sécurité",
  securitySettingsDesc: "Configurez les paramètres de sécurité et d'accès",
  defaultSettings: "Paramètres par défaut",
  defaultSettingsDesc: "Définissez les valeurs par défaut pour vos établissements",
  hoursSettings: "Horaires d'ouverture par default",
  hoursSettingsDesc: "Horaires appliqués par défaut aux nouveaux établissements",
}

export function Account(props) {
  const { mpId, mpEmail, mpRole } = useContext(authContext)
  const [mpName, setMpName] = useState(getMPNameFromLocalStorage())

  const [errorMessage, setErrorMessage] = useState("test error message")
  const [errorMessageShowing, setErrorMessageShowing] = useState(false)
  const [businessType, setBusinessType] = useState(undefined)
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const [base64Image, setBase64Image] = useState(undefined)
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    defaultSubCompanyPassword: "",
    phone: "",
    cover: "",
    demo: false,
    businessLimit: 0,
    businessType: 0,
    emailSubCompanyEvent: true,
    defaultSubCompanyWorkingHours: [],
  })
  const [loading, setLoading] = useState(true)
  const [imageCompany, setImageCompany] = useState(undefined)
  const [imagesData, setImagesData] = useState()
  const [info, setInfo] = useState({
    name: "green",
    email: "green",
    password: "green",
    confirm_password: "green",
    defaultSubCompanyPassword: "green",
    emailSubCompanyEvent: "green",
    phone: "green",
    cover: "green",
    businessLimit: "grey",
    businessType: "green",
  })
  const [check, setCheck] = useState({
    check_companyMissing: false,
    check_emailMissing: false,
    check_lastNameMissing: false,
    check_coordsMissing: false,
    check_phoneMissing: false,
    check_emailInputChange: true,
    check_textInputChange: false,
    secureTextEntry: true,
    confirm_secureTextEntry: true,
  })
  const [showAlert, setShowAlert] = useState(false)
  const [typeAlert, setTypeAlert] = useState("success")
  const [alertMessageBox, setAlertMessageBox] = useState(
    "Bravo, vos modifications ont été enregistrées."
  )

  useEffect(() => {
    if (mpId && mpEmail) {
      Promise.all([getMultiproAccountData(mpId, mpEmail), getBusinessType()])
        .then(([responseAccount, responseBusiness]) => {
          if (responseAccount.status === 200 && responseBusiness.status === 200) {
            const x = responseAccount.data.data
            const u = responseAccount.data.user
            const st = responseBusiness.data.map(({ id, name, icon }) => ({
              key: id,
              label: name,
              icon: icon,
            }))

            setBusinessType(st)
            setData({
              name: x.name,
              email: u.email,
              password: "",
              confirm_password: "",
              defaultSubCompanyPassword: x?.defaultSubCompanyPassword,
              emailSubCompanyEvent: x?.emailSubCompanyEvent ?? true,
              phone: x.phone || "",
              detail: x.detail,
              cover: x.iscover,
              demo: x.demo,
              businessLimit: x.businessLimit,
              businessType: (x.businessType && x.businessType.id) || 0,
              defaultSubCompanyWorkingHours: x.defaultSubCompanyWorkingHours ?? [],
            })

            setLoading(false)
          }
        })
        .catch((e) => {
          console.log("catch", e)
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [mpEmail, mpId])

  useEffect(() => {
    if (mpId)
      setImageCompany(
        BASE_URL + "img/multipro/cover-" + mpId + ".jpg?date=" + new Date().getTime()
      )
  }, [mpId])

  const handleInputChange = (_text, _fromWich) => {
    setData({ ...data, [_fromWich]: _text })
    switch (_fromWich) {
      case "name":
        setInfo({ ...info, [_fromWich]: _text ? "#495057" : "coral" })
        break
      case "email":
        if (isEmail(_text)) {
          setInfo({ ...info, [_fromWich]: "green" })
        } else {
          setInfo({ ...info, [_fromWich]: "coral" })
        }
        break
      case "phone":
        if (isMobilePhone(_text)) {
          setInfo({ ...info, [_fromWich]: "green" })
        } else {
          setInfo({ ...info, [_fromWich]: "coral" })
        }
        break
    }
  }

  const handleChangeBusinessType = (e) => {
    e.preventDefault()
    setData({ ...data, businessType: e.target.value })
  }

  const handleRegister = () => {
    let showAlert = false
    setLoading(true)

    if (data.name.length === 0) {
      setInfo((prevState) => {
        return { ...prevState, companyName: ALERT_COLOR }
      })
      showAlert = true
    }
    if (data.email.length === 0) {
      setInfo((prevState) => {
        return { ...prevState, email: ALERT_COLOR }
      })
      showAlert = true
    }
    if (showAlert === false) {
      if (mpId) {
        setMultiproAccountData(data, mpId, base64Image)
          .then((response) => {
            setMPNameFromLocalStorage(data.name)
            setMpName(data.name)
            setLoading(false)
            setShowAlert(true)
          })
          .catch((e) => {
            console.log(e)
            alert("Une erreur est survenue")
            setLoading(false)
          })
      }
    } else {
      setErrorMessage("Veuillez vérifier vos données")
      setErrorMessageShowing(true)
      setTimeout(() => {
        setErrorMessageShowing(false)
        setLoading(false)
      }, 2000)
    }
  }

  const showInfo = () => {
    setShowAlert(!showAlert)
  }

  const getPlanning = (_data) => {
    setData({ ...data, ["defaultSubCompanyWorkingHours"]: _data })
  }

  const buttonClasses = useButtonStyles()
  const classes = useStyles()
  const classesExtended = useStylesExtended()
  const classesLocal = useLocalStyle()
  const disabled = useDisabledStyle()

  return (
    <div className={classesLocal.mainContainer}>
      {!loading ? (
        <div className={classesLocal.contentWrapper}>
          <JAlert
            type={typeAlert}
            show={showAlert}
            localStatus={showInfo}
            titleText={alertMessageBox}
            subTitleText={
              typeAlert === "success" ? "...et elles sont déjà actives." : ""
            }
          />

          {/* Header */}
          <div className={classesLocal.headerCard}>
            <div className={classesLocal.pageTitle}>
              <BusinessCenter style={{ fontSize: "40px", color: "#667eea" }} />
              {mpName ? mpName : "Nom de votre Société"}
              {data && data?.demo && (
                <span className={classesLocal.demoTag}>MODE DÉMO</span>
              )}
            </div>
            <p className={classesLocal.pageSubtitle}>
              Gérez les paramètres et informations de votre compte professionnel
            </p>
          </div>

          {/* Section 1: Informations générales */}
          <Paper className={classesLocal.sectionCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionIcon}>
                <Apartment />
              </div>
              <div>
                <h3 className={classesLocal.sectionTitle}>{label.generalInfo}</h3>
                <p className={classesLocal.sectionDescription}>
                  {label.generalInfoDesc}
                </p>
              </div>
            </div>

            <GridContainer spacing={3}>
              <GridItem xs={12} md={6}>
                <div className={classesLocal.inputGroup}>
                  <CustomInput
                    labelText={label.company}
                    id="name"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Apartment style={{ color: info.name }} />
                        </InputAdornment>
                      ),
                      type: "text",
                      value: data?.name,
                      onChange: (e) => {
                        handleInputChange(e.target.value, "name")
                      },
                    }}
                  />
                </div>
              </GridItem>

              <GridItem xs={12} md={6}>
                <div className={classesLocal.inputGroup}>
                  <CustomInput
                    labelText={label.email}
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AlternateEmail style={{ color: info.email }} />
                        </InputAdornment>
                      ),
                      type: "email",
                      value: data?.email,
                      onChange: (e) => {
                        handleInputChange(e.target.value, "email")
                      },
                    }}
                  />
                </div>
              </GridItem>

              <GridItem xs={12} md={6}>
                <div className={classesLocal.inputGroup}>
                  <CustomInput
                    labelText="Téléphone"
                    id="phone"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Phone style={{ color: info.phone }} />
                        </InputAdornment>
                      ),
                      type: "text",
                      value: data?.phone,
                      onChange: (e) => {
                        handleInputChange(e.target.value, "phone")
                      },
                    }}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </Paper>

          {/* Section 2: Sécurité */}
          <Paper className={classesLocal.sectionCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionIcon}>
                <Security />
              </div>
              <div>
                <h3 className={classesLocal.sectionTitle}>
                  {label.securitySettings}
                </h3>
                <p className={classesLocal.sectionDescription}>
                  {label.securitySettingsDesc}
                </p>
              </div>
            </div>

            <GridContainer spacing={3}>
              <GridItem xs={12}>
                <ChangePasswordModal />
              </GridItem>
            </GridContainer>
          </Paper>

          {/* Section 3: Paramètres par défaut */}
          <Paper className={classesLocal.sectionCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionIcon}>
                <Settings />
              </div>
              <div>
                <h3 className={classesLocal.sectionTitle}>
                  {label.defaultSettings}
                </h3>
                <p className={classesLocal.sectionDescription}>
                  {label.defaultSettingsDesc}
                </p>
              </div>
            </div>

            <GridContainer spacing={3}>
              <GridItem xs={12} md={6}>
                <div className={classesLocal.inputGroup}>
                  <CustomInput
                    labelText={
                      <>
                        {label.defaultSubCompanyPassword}
                        <Tooltip
                          title={
                            <p style={{ fontSize: 12 }}>
                              Ce mot de passe par défaut sera envoyé à vos
                              responsables d'établissements
                              <br />
                              Il leur sera conseillé de le changer dès que possible.
                            </p>
                          }
                        >
                          <IconButton style={{ height: 18 }}>
                            <InfoRounded style={{ color: "#42988d" }} />
                          </IconButton>
                        </Tooltip>
                      </>
                    }
                    id="defaultSubCompanyPassword"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Lock style={{ color: info.defaultSubCompanyPassword }} />
                        </InputAdornment>
                      ),
                      type: "text",
                      value: data?.defaultSubCompanyPassword,
                      onChange: (e) => {
                        handleInputChange(
                          e.target.value,
                          "defaultSubCompanyPassword"
                        )
                      },
                    }}
                  />
                </div>
              </GridItem>

              <GridItem xs={12} md={6}>
                <div
                  className={classesLocal.inputGroup}
                  style={{ paddingTop: "16px" }}
                >
                  <div className={classesExtended.block}>
                    <FormControlLabel
                      control={
                        <Switch
                          id="emailingEvent"
                          checked={!!Number(data.emailSubCompanyEvent)}
                          onChange={(event) => {
                            handleInputChange(
                              event.target.checked,
                              "emailSubCompanyEvent"
                            )
                          }}
                          classes={{
                            switchBase: classesExtended.switchBase,
                            checked: classesExtended.switchChecked,
                            thumb: classesExtended.switchIcon,
                            track: classesExtended.switchBar,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                      }}
                      label={
                        data.emailSubCompanyEvent
                          ? label.emailingEventOff
                          : label.emailingEventOn
                      }
                    />
                  </div>
                </div>
              </GridItem>

              <GridItem xs={12} md={6}>
                <div className={classesLocal.inputGroup}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="business-type"
                      className={classesExtended.selectLabel}
                      style={{ marginLeft: 0 }}
                    >
                      {label.businessType}
                    </InputLabel>

                    {data.businessType !== undefined &&
                    businessType !== undefined ? (
                      <Select
                        value={data.businessType}
                        onChange={handleChangeBusinessType}
                        MenuProps={{ className: classesExtended.selectMenu }}
                        classes={{ select: classesExtended.select }}
                        inputProps={{
                          name: "businessType",
                          id: "business-type",
                        }}
                      >
                        {businessType.map((type) => {
                          return (
                            <MenuItem
                              id={type.key}
                              key={type.key}
                              classes={{
                                root: classesExtended.selectMenuItem,
                                selected:
                                  classesExtended.selectMenuItemSelectedMultiple,
                              }}
                              value={type.key}
                            >
                              {type.label}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    ) : null}
                  </FormControl>
                </div>
              </GridItem>
            </GridContainer>

            <div className={classesLocal.infoBox}>
              <InfoRounded className={classesLocal.infoIcon} />
              <p className={classesLocal.infoText}>
                Ces paramètres seront appliqués automatiquement lors de la création
                de nouveaux établissements ou de l'import en masse. Vous pourrez les
                modifier individuellement par la suite.
                <br />
                La modification de ces paramètres n'affectera pas vos établissements
                déjà créés.
              </p>
            </div>
          </Paper>

          {/* Section 4: Horaires d'ouverture */}
          <Paper className={classesLocal.sectionCard}>
            <div className={classesLocal.sectionHeader}>
              <div className={classesLocal.sectionIcon}>
                <Schedule />
              </div>
              <div>
                <h3 className={classesLocal.sectionTitle}>{label.hoursSettings}</h3>
                <p className={classesLocal.sectionDescription}>
                  {label.hoursSettingsDesc}
                </p>
              </div>
            </div>

            <GridContainer>
              <GridItem xs={12}>
                <div className={classesExtended.block}>
                  <WorkingHours
                    fieldName={"location[working_hours]"}
                    dataStr={data.defaultSubCompanyWorkingHours}
                    backFire={(a) => getPlanning(a)}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </Paper>

          {/* Bouton de sauvegarde */}
          <div style={{ textAlign: "center", marginTop: "32px" }}>
            <Button
              className={classesLocal.saveButton}
              onClick={() => {
                handleRegister()
              }}
            >
              <Save style={{ marginRight: "8px" }} /> {label.save}
            </Button>
          </div>
        </div>
      ) : (
        <div className={disabled.disabledBack}>
          <GridLoader
            color="#667eea"
            loading={loading}
            size={50}
            css={`
              position: absolute;
              display: block;
              z-index: 999;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            `}
          />
        </div>
      )}
    </div>
  )
}
// /*eslint-disable*/
// import React, { useContext, useEffect, useRef, useState } from "react"
// import isEmail from "validator/lib/isEmail"
// import isURL from "validator/lib/isURL"
// import isMobilePhone from "validator/es/lib/isMobilePhone"
// import { ContentState, convertFromHTML, convertToRaw, EditorState } from "draft-js"
// import { GridLoader } from "react-spinners"
//
// // @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles"
// import InputAdornment from "@material-ui/core/InputAdornment"
//
// // core components
// import GridContainer from "components/Grid/GridContainer.js"
// import GridItem from "components/Grid/GridItem.js"
// import CustomInput from "components/CustomInput/CustomInput.js"
// import Button from "components/CustomButtons/Button.js"
// import Card from "components/Card/Card.js"
// import CardHeader from "components/Card/CardHeader.js"
// import CardText from "components/Card/CardText.js"
// import CardBody from "components/Card/CardBody.js"
//
// import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
// import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js"
// import buttonStyles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js"
//
// import ImageUpload from "../../components/CustomUpload/ImageUpload"
// import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle"
// import customCheckboxRadioSwitch from "../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch"
// import Favorite from "@material-ui/icons/Favorite"
//
// import {
//   AlternateEmail,
//   Apartment,
//   InfoRounded,
//   Lock,
//   People,
//   Phone,
//   TitleRounded,
//   Web,
// } from "@material-ui/icons"
//
// // Private Component
// import JAlert from "../../components/smallComponent/jAlert"
// import WorkingHours from "../../utils/hours/workingHours"
//
// // Context & API
// import authContext from "../../context/AuthContext"
// import {
//   getBusinessType,
//   getMultiproAccountData,
//   setMultiproAccountData,
// } from "../../api/companyAction"
// import config from "../../config"
// import {
//   getMPNameFromLocalStorage,
//   setMPNameFromLocalStorage,
// } from "../../services/AuthApi"
// import { Tooltip } from "@material-ui/core"
// import IconButton from "@material-ui/core/IconButton"
// import Switch from "@material-ui/core/Switch"
// import FormControlLabel from "@material-ui/core/FormControlLabel"
// import Divider from "@material-ui/core/Divider"
// import ChangePasswordModal from "../../components/Button/ChangePasswordModal"
// import InputLabel from "@material-ui/core/InputLabel"
// import Select from "@material-ui/core/Select"
// import FormControl from "@material-ui/core/FormControl"
// import MenuItem from "@material-ui/core/MenuItem"
//
// const localStyles = {
//   infoText: {
//     fontWeight: "300",
//     margin: "10px 0 30px",
//     textAlign: "center",
//   },
//   inputAdornmentIcon: {
//     color: "#555",
//   },
//   choiche: {
//     textAlign: "center",
//     cursor: "pointer",
//     marginTop: "20px",
//   },
//   ...customSelectStyle,
//   ...customCheckboxRadioSwitch,
// }
//
// const disabledStyle = {
//   disabledBack: {
//     backgroundColor: "red",
//   },
// }
//
// const useDisabledStyle = makeStyles(disabledStyle)
// const useButtonStyles = makeStyles(buttonStyles)
// const useLocalStyle = makeStyles(localStyles)
// const useStyles = makeStyles(styles)
// const useStylesExtended = makeStyles(stylesExtended)
//
// const BASE_URL = config.BASE_URL
//
// const days = [
//   { key: "mon", name: "Lundi" },
//   { key: "tue", name: "Mardi" },
//   { key: "wed", name: "Mercredi" },
//   { key: "thu", name: "Jeudi" },
//   { key: "fri", name: "Vendredi" },
//   { key: "sat", name: "Samedi" },
//   { key: "sun", name: "Dimanche" },
// ]
//
// const label = {
//   formTitle: "Mon compte",
//   visuel: "Visuel",
//   company: "société*",
//   companies: "Choisir un ou plusieurs établissements",
//   name: "Nom du contact",
//   description: "description",
//   suspended: "Suspendu ?",
//   image: "Image de profil",
//   openingHours: "Horaire d'ouverture",
//   site: "site internet",
//   phone: "téléphone",
//   save: "Enregistrer",
//   latitude: "Latitude",
//   longitude: "Longitude",
//   address: "Adresse",
//   email: "Email*",
//   defaultSubCompanyPassword: "Mot de passe par défaut pour vos établissements",
//   emailingEventOn: "Envoi d'email aux établissements désactivé",
//   emailingEventOff: "Envoi d'email aux établissements activé",
//   moreParameters: "Paramètres supplémentaires",
//   moreParametersExplanation:
//     "Vous pouvez définir des paramètres par defaut pour vos établissements",
//   businessType: "Type d'établissement par défaut",
// }
//
// const ALERT_COLOR = "coral"
//
// export function Account(props) {
//   const { mpId, mpEmail, mpRole } = useContext(authContext)
//   const [mpName, setMpName] = useState(getMPNameFromLocalStorage())
//
//   // const [checked, setChecked] = useState([24, 22])
//   // const [selectedEnabled, setSelectedEnabled] = useState("b")
//   // const [selectedValue, setSelectedValue] = useState(null)
//   // const [simpleSelect, setSimpleSelect] = useState("")
//   // const [actif, setActif] = useState(false)
//   // const [confirmMessage, setConfirmMessage] = useState("")
//   const [errorMessage, setErrorMessage] = useState("test error message")
//   const [errorMessageShowing, setErrorMessageShowing] = useState(false)
//   const [businessType, setBusinessType] = useState(undefined)
//   const [editorState, setEditorState] = useState(EditorState.createEmpty())
//   const [base64Image, setBase64Image] = useState(undefined)
//   const [data, setData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     confirmPassword: "",
//     defaultSubCompanyPassword: "",
//     phone: "",
//     cover: "",
//     demo: false,
//     businessLimit: 0,
//     businessType: 0,
//     emailSubCompanyEvent: true,
//     defaultSubCompanyWorkingHours: [],
//   })
//   const [loading, setLoading] = useState(true)
//   const [imageCompany, setImageCompany] = useState(undefined)
//   const [imagesData, setImagesData] = useState()
//   const [info, setInfo] = useState({
//     name: "green",
//     email: "green",
//     password: "green",
//     confirm_password: "green",
//     defaultSubCompanyPassword: "green",
//     emailSubCompanyEvent: "green",
//     phone: "green",
//     cover: "green",
//     businessLimit: "grey",
//     businessType: "green",
//   })
//   const [check, setCheck] = useState({
//     check_companyMissing: false,
//     check_emailMissing: false,
//     check_lastNameMissing: false,
//     check_coordsMissing: false,
//     check_phoneMissing: false,
//     check_emailInputChange: true,
//     check_textInputChange: false,
//     secureTextEntry: true,
//     confirm_secureTextEntry: true,
//   })
//   const [showAlert, setShowAlert] = useState(false)
//   const [typeAlert, setTypeAlert] = useState("success")
//   const [alertMessageBox, setAlertMessageBox] = useState(
//     "Bravo, vos modifications ont été enregistrées."
//   )
//
//   /**
//    * Note : Get USER DATA
//    */
//   // useEffect(() => {
//   //   if (mpId && mpEmail)
//   //     getMultiproAccountData(mpId, mpEmail)
//   //       .then((response) => {
//   //         if (typeof response.data !== "undefined") {
//   //           if (response.status === 200) {
//   //             // console.log("response mpid", response.data)
//   //             let x = response.data.data
//   //             let u = response.data.user
//   //             console.log("multicompte data", response.data.data)
//   //             setData({
//   //               ...data,
//   //               name: x.name,
//   //               email: u.email,
//   //               password: "",
//   //               confirm_password: "",
//   //               defaultSubCompanyPassword: x?.defaultSubCompanyPassword,
//   //               emailSubCompanyEvent: x?.emailSubCompanyEvent ?? true,
//   //               phone: x.phone || "",
//   //               detail: x.detail,
//   //               cover: x.iscover,
//   //               demo: x.demo,
//   //               businessLimit: 0,
//   //               businessType: x.businessType.id,
//   //               defaultSubCompanyWorkingHours: x.defaultSubCompanyWorkingHours
//   //                 ? x?.defaultSubCompanyWorkingHours
//   //                 : [],
//   //             })
//   //             console.log("info business type", x.businessType.id)
//   //             setLoading(false)
//   //           }
//   //         }
//   //       })
//   //       .catch((e) => {
//   //         console.log("catch", e)
//   //         /** Manage problem with token
//   //          * - Expired JWT Token
//   //          * - Invalid JWT Token
//   //          */
//   //       })
//   //   else setLoading(false)
//   // }, [mpEmail, mpId])
//   //
//   // /**
//   //  * Note : Fill The Business Type Selector
//   //  */
//   // useEffect(() => {
//   //   getBusinessType()
//   //     .then((response) => {
//   //       if (typeof response.data !== "undefined") {
//   //         if (response.status >= 200 && response.status <= 299) {
//   //           let st = response.data.map(({ id, name, icon, ...rest }) => ({
//   //             key: id,
//   //             label: name,
//   //             icon: icon,
//   //           }))
//   //           setBusinessType(st)
//   //         }
//   //       }
//   //     })
//   //     .catch((e) => console.log(e))
//   // }, [])
//
//   useEffect(() => {
//     if (mpId && mpEmail) {
//       Promise.all([getMultiproAccountData(mpId, mpEmail), getBusinessType()])
//         .then(([responseAccount, responseBusiness]) => {
//           if (responseAccount.status === 200 && responseBusiness.status === 200) {
//             const x = responseAccount.data.data
//             const u = responseAccount.data.user
//             const st = responseBusiness.data.map(({ id, name, icon }) => ({
//               key: id,
//               label: name,
//               icon: icon,
//             }))
//
//             setBusinessType(st)
//             setData({
//               name: x.name,
//               email: u.email,
//               password: "",
//               confirm_password: "",
//               defaultSubCompanyPassword: x?.defaultSubCompanyPassword,
//               emailSubCompanyEvent: x?.emailSubCompanyEvent ?? true,
//               phone: x.phone || "",
//               detail: x.detail,
//               cover: x.iscover,
//               demo: x.demo,
//               businessLimit: x.businessLimit,
//               businessType: (x.businessType && x.businessType.id) || 0,
//               defaultSubCompanyWorkingHours: x.defaultSubCompanyWorkingHours ?? [],
//             })
//
//             setLoading(false)
//           }
//         })
//         .catch((e) => {
//           console.log("catch", e)
//           setLoading(false)
//         })
//     } else {
//       setLoading(false)
//     }
//   }, [mpEmail, mpId])
//
//   /**
//    * Note : reloading image each time...
//    */
//   useEffect(() => {
//     if (mpId)
//       setImageCompany(
//         BASE_URL + "img/multipro/cover-" + mpId + ".jpg?date=" + new Date().getTime()
//       )
//   }, [mpId])
//
//   /**
//    * Note: management of simple input
//    * @param _text
//    * @param _fromWich
//    */
//   const handleInputChange = (_text, _fromWich) => {
//     setData({ ...data, [_fromWich]: _text })
//     switch (_fromWich) {
//       case "name":
//         setInfo({ ...info, [_fromWich]: _text ? "#495057" : "coral" })
//         break
//       case "email":
//         if (isEmail(_text)) {
//           setInfo({ ...info, [_fromWich]: "green" })
//         } else {
//           setInfo({ ...info, [_fromWich]: "coral" })
//         }
//         break
//       case "phone":
//         if (isMobilePhone(_text)) {
//           setInfo({ ...info, [_fromWich]: "green" })
//         } else {
//           setInfo({ ...info, [_fromWich]: "coral" })
//         }
//         break
//     }
//   }
//
//   /**
//    * Note : management of businessType Change
//    * @param e
//    */
//   const handleChangeBusinessType = (e) => {
//     e.preventDefault()
//     setData({ ...data, businessType: e.target.value })
//   }
//
//   /**
//    * ###############################################################################
//    * Saving the data                      handleRegister
//    * ###############################################################################
//    * */
//   const handleRegister = () => {
//     let showAlert = false
//     setLoading(true)
//
//     if (data.name.length === 0) {
//       setInfo((prevState) => {
//         return { ...prevState, companyName: ALERT_COLOR }
//       })
//       showAlert = true
//     }
//     if (data.email.length === 0) {
//       setInfo((prevState) => {
//         return { ...prevState, email: ALERT_COLOR }
//       })
//       showAlert = true
//     }
//     if (showAlert === false) {
//       // Updating text data
//       if (mpId) {
//         setMultiproAccountData(data, mpId, base64Image)
//           .then((response) => {
//             setMPNameFromLocalStorage(data.name)
//             setMpName(data.name)
//             setLoading(false)
//             setShowAlert(true)
//           })
//           .catch((e) => {
//             console.log(e)
//             alert("Une erreur est survenue")
//             setLoading(false)
//           })
//         // Updating image if necessary
//         // if (isNewImage) {
//         //   uploadImageCompany(cid, imagesData)
//         //     .then((response) => {
//         //       setLoading(false)
//         //     })
//         //     .catch((e) => {
//         //       console.log(e)
//         //       alert("Update image failure")
//         //       setLoading(false)
//         //     })
//         // }}
//       }
//     } else {
//       // Information about the errors or missing data
//       setErrorMessage("Veuillez vérifier vos données")
//       setErrorMessageShowing(true)
//       setTimeout(() => {
//         setErrorMessageShowing(false)
//         setLoading(false)
//       }, 2000)
//     }
//   }
//
//   /**
//    * Note : Alert manager
//    */
//   const showInfo = () => {
//     setShowAlert(!showAlert)
//   }
//
//   /**
//    * Note Get information from child component Working Hours
//    * @param _data
//    */
//   const getPlanning = (_data) => {
//     // console.log("backfire", _data.toString())
//     setData({ ...data, ["defaultSubCompanyWorkingHours"]: _data })
//   }
//
//   // Style construction (multi theme options...)
//   const buttonClasses = useButtonStyles()
//   const classes = useStyles()
//   const classesExtended = useStylesExtended()
//   const classesLocal = useLocalStyle()
//   const disabled = useDisabledStyle()
//
//   return (
//     <div>
//       {!loading ? (
//         <GridContainer>
//           {/*Large Form*/}
//           <JAlert
//             type={typeAlert}
//             show={showAlert}
//             localStatus={showInfo}
//             titleText={alertMessageBox}
//             subTitleText={
//               typeAlert === "success " ? "...et elles sont déjà actives." : ""
//             }
//           />
//           <GridItem xs={12}>
//             <Card>
//               <CardHeader color="rose" text>
//                 <CardText color="rose">
//                   <h4 className={classes.cardTitle}>
//                     {mpName ? mpName : "Nom de votre Société"}
//                   </h4>
//                   {data && data?.demo && (
//                     <p style={{ fontStyle: "italic" }}>
//                       Vous êtes actuellement en mode 'démo'
//                     </p>
//                   )}
//                 </CardText>
//               </CardHeader>
//               <CardBody>
//                 <form>
//                   <GridContainer
//                     container
//                     spacing={1}
//                     direction="row"
//                     alignItems="center"
//                   >
//                     <GridItem xs={12} sm={6}>
//                       <CustomInput
//                         labelText={label.company}
//                         id="name"
//                         formControlProps={{
//                           fullWidth: true,
//                         }}
//                         inputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <Apartment style={{ color: info.companyName }} />
//                             </InputAdornment>
//                           ),
//                           type: "text",
//                           value: data?.name,
//                           onChange: (e) => {
//                             handleInputChange(e.target.value, "name")
//                           },
//                         }}
//                       />
//
//                       {/** ################################################ **/}
//                       {/** ################  BUSINESS TYPE ################ **/}
//                       {/** ################################################ **/}
//                       <FormControl
//                         fullWidth
//                         className={classesExtended.selectFormControl}
//                       >
//                         <InputLabel
//                           htmlFor="business-type"
//                           className={classesExtended.selectLabel}
//                           style={{ marginLeft: 0 }}
//                         >
//                           {label.businessType}
//                         </InputLabel>
//
//                         {data.businessType !== undefined &&
//                         businessType !== undefined ? (
//                           <Select
//                             value={data.businessType}
//                             onChange={handleChangeBusinessType}
//                             MenuProps={{ className: classesExtended.selectMenu }}
//                             classes={{ select: classesExtended.select }}
//                             inputProps={{
//                               name: "businessType",
//                               id: "business-type",
//                             }}
//                           >
//                             {businessType.map((type) => {
//                               return (
//                                 <MenuItem
//                                   id={type.key}
//                                   key={type.key}
//                                   classes={{
//                                     root: classesExtended.selectMenuItem,
//                                     selected:
//                                       classesExtended.selectMenuItemSelectedMultiple,
//                                   }}
//                                   value={type.key}
//                                 >
//                                   {type.label}
//                                 </MenuItem>
//                               )
//                             })}
//                           </Select>
//                         ) : null}
//                       </FormControl>
//                       {/*<CustomInput*/}
//                       {/*  labelText={label.name}*/}
//                       {/*  id="lastname"*/}
//                       {/*  formControlProps={{*/}
//                       {/*    fullWidth: true,*/}
//                       {/*  }}*/}
//                       {/*  inputProps={{*/}
//                       {/*    endAdornment: (*/}
//                       {/*      <InputAdornment position="end">*/}
//                       {/*        <People style={{ color: info.lastName }} />*/}
//                       {/*      </InputAdornment>*/}
//                       {/*    ),*/}
//                       {/*    type: "text",*/}
//                       {/*    value: data?.lastName,*/}
//                       {/*    onChange: (e) => {*/}
//                       {/*      handleInputChange(e.target.value, "lastName")*/}
//                       {/*    },*/}
//                       {/*  }}*/}
//                       {/*/>*/}
//
//                       {/** ################################################ **/}
//                       {/** ####################     EMAIL     ############# **/}
//                       {/** ################################################ **/}
//                       <CustomInput
//                         labelText={label.email}
//                         id="email"
//                         formControlProps={{
//                           fullWidth: true,
//                         }}
//                         inputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <AlternateEmail style={{ color: info.email }} />
//                             </InputAdornment>
//                           ),
//                           type: "email",
//                           value: data?.email,
//                           onChange: (e) => {
//                             handleInputChange(e.target.value, "email")
//                           },
//                         }}
//                       />
//                       {/** ################################################ **/}
//                       {/** ####################     PHONE     ############# **/}
//                       {/** ################################################ **/}
//                       <CustomInput
//                         labelText="Téléphone"
//                         id="phone"
//                         formControlProps={{
//                           fullWidth: true,
//                         }}
//                         inputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <Phone />
//                             </InputAdornment>
//                           ),
//                           type: "text",
//                           value: data?.phone,
//                           onChange: (e) => {
//                             handleInputChange(e.target.value, "phone")
//                           },
//                         }}
//                       />
//                       {/** ################################################ **/}
//                       {/** #############    MAIN PASSWORD     ############# **/}
//                       {/** ################################################ **/}
//                       <ChangePasswordModal />
//
//                       <Divider />
//
//                       {/** ################################################ **/}
//                       {/** #######    MORE PARAMETERS               ####### **/}
//                       {/** ################################################ **/}
//                       <div style={{ textAlign: "center", marginTop: 40 }}>
//                         <h4 className={classes.cardTitle}>{label.moreParameters}</h4>
//                         <h6
//                           style={{
//                             marginBottom: "20px",
//                             fontSize: "0.8rem",
//                           }}
//                         >
//                           {label.moreParametersExplanation}
//                         </h6>
//                       </div>
//
//                       {/** ################################################ **/}
//                       {/** #######    defaultSubCompanyPassword     ####### **/}
//                       {/** ################################################ **/}
//                       <CustomInput
//                         labelText={
//                           <>
//                             <>{label.defaultSubCompanyPassword}</>
//                             <Tooltip
//                               title={
//                                 <p style={{ fontSize: 12 }}>
//                                   Ce mot de passe par défault sera envoyé à vos
//                                   responsables d'établissements
//                                   <br />
//                                   Il leur sera conseillé de le changer dès que
//                                   possible.
//                                 </p>
//                               }
//                             >
//                               <IconButton style={{ height: 18 }}>
//                                 <InfoRounded style={{ color: "#42988d" }} />
//                               </IconButton>
//                             </Tooltip>
//                           </>
//                         }
//                         id="defaultSubCompanyPassword"
//                         formControlProps={{
//                           fullWidth: true,
//                         }}
//                         inputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <Lock style={{ color: info.companyName }} />
//                             </InputAdornment>
//                           ),
//                           type: "text",
//                           value: data?.defaultSubCompanyPassword,
//                           onChange: (e) => {
//                             handleInputChange(
//                               e.target.value,
//                               "defaultSubCompanyPassword"
//                             )
//                           },
//                         }}
//                       />
//                       {/** ################################################ **/}
//                       {/** #################    emailingEvent    ########## **/}
//                       {/** ################################################ **/}
//                       <div className={classesExtended.block}>
//                         <FormControlLabel
//                           control={
//                             <Switch
//                               id="emailingEvent"
//                               checked={!!Number(data.emailSubCompanyEvent)}
//                               onChange={(event) => {
//                                 // setIsFree(event.target.checked)
//                                 handleInputChange(
//                                   event.target.checked,
//                                   "emailSubCompanyEvent"
//                                 )
//                               }}
//                               //value={isFree}
//                               classes={{
//                                 switchBase: classesExtended.switchBase,
//                                 checked: classesExtended.switchChecked,
//                                 thumb: classesExtended.switchIcon,
//                                 track: classesExtended.switchBar,
//                               }}
//                             />
//                           }
//                           classes={{
//                             label: classes.label,
//                           }}
//                           label={
//                             data.emailSubCompanyEvent
//                               ? label.emailingEventOff
//                               : label.emailingEventOn
//                           }
//                         />
//                       </div>
//                     </GridItem>
//                     {/** ################################################ **/}
//                     {/** ####################  VISUEL       ############# **/}
//                     {/** ################################################ **/}
//                     {/*Suppression de l'affichage de l'iamge sur demand jlaffont*/}
//
//                     {/*<GridItem xs={12} sm={4}>*/}
//                     {/*  <GridContainer*/}
//                     {/*    container*/}
//                     {/*    spacing={1}*/}
//                     {/*    direction="column"*/}
//                     {/*    alignItems="center"*/}
//                     {/*  >*/}
//                     {/*    <legend style={{ textAlign: "center" }}>*/}
//                     {/*      {label.image}*/}
//                     {/*    </legend>*/}
//                     {/*    <ImageUpload*/}
//                     {/*      b64={(x) => {*/}
//                     {/*        setBase64Image(x)*/}
//                     {/*      }}*/}
//                     {/*      modification={true}*/}
//                     {/*      avatar*/}
//                     {/*      url={imageCompany}*/}
//                     {/*      addButtonProps={{*/}
//                     {/*        color: "rose",*/}
//                     {/*        round: true,*/}
//                     {/*      }}*/}
//                     {/*      changeButtonProps={{*/}
//                     {/*        color: "rose",*/}
//                     {/*        round: true,*/}
//                     {/*      }}*/}
//                     {/*      removeButtonProps={{*/}
//                     {/*        color: "danger",*/}
//                     {/*        round: true,*/}
//                     {/*      }}*/}
//                     {/*    />*/}
//                     {/*  </GridContainer>*/}
//                     {/*</GridItem>*/}
//                     {/*<Divider />*/}
//                     {/** ################################################ **/}
//                     {/** #################    Opening Hours    ########## **/}
//                     {/** ################################################ **/}
//                     <GridContainer
//                       container
//                       spacing={2}
//                       direction="column"
//                       alignItems="center"
//                       style={{ marginTop: 40 }}
//                     >
//                       <GridItem xs={12} sm={12}>
//                         <legend style={{ textAlign: "center" }}>
//                           {label.openingHours}
//                         </legend>
//                         <div className={classesExtended.block}>
//                           <WorkingHours
//                             fieldName={"location[working_hours]"}
//                             dataStr={data.defaultSubCompanyWorkingHours}
//                             backFire={(a) => getPlanning(a)}
//                           />
//                         </div>
//                       </GridItem>
//                     </GridContainer>
//
//                     <GridContainer
//                       container
//                       spacing={0}
//                       direction="column"
//                       alignItems="center"
//                     >
//                       <GridItem>
//                         <Button
//                           color="success"
//                           round
//                           onClick={() => {
//                             handleRegister()
//                           }}
//                         >
//                           <Favorite className={buttonClasses.icons} /> Enregistrer
//                         </Button>
//                       </GridItem>
//                     </GridContainer>
//                   </GridContainer>
//                 </form>
//               </CardBody>
//             </Card>
//           </GridItem>
//         </GridContainer>
//       ) : (
//         <div className={disabled.disabledBack}>
//           <GridLoader
//             color="#3f4850"
//             loading={loading}
//             size={50}
//             css={`
//               position: absolute;
//               display: block;
//               z-index: 999;
//               top: 50%;
//               left: 50%;
//               transform: translate(-50%, -50%);
//             `}
//           />
//           <JAlert
//             type="success"
//             show={showAlert}
//             localStatus={showInfo}
//             titleText="Bravo, vos modifications ont été enregistrées."
//             subTitleText="...et elles sont déjà actives."
//           />
//         </div>
//       )}
//     </div>
//   )
// }
